<template>
    <Row style="height: 100%;width: 100%" type="flex" id="imgTools1">
        <Row type="flex">
            <i-col :md="12" :lg="8">
                <Card style="margin: 10px 0">
                    <p slot="title">1.临床诊断</p>
                    <div class="group-row">
                        <Form :label-width="120">
                            <FormItem label="发育障碍：" v-if="caseInfo['发育障碍'] != null">
                                <Select transfer multiple v-model.sync="caseInfo['发育障碍']['answer']" placeholder="请选择">
                                    <Option v-for="item in caseInfo['发育障碍']['choice']" :value="item" :key="item">
                                        {{ item }}
                                    </Option>
                                </Select>
                            </FormItem>
                            <FormItem label="过敏性疾病：" v-if="caseInfo['过敏性疾病'] != null">
                                <Select transfer multiple v-model.sync="caseInfo['过敏性疾病']['answer']" placeholder="请选择">
                                    <Option v-for="item in caseInfo['过敏性疾病']['choice']" :value="item" :key="item">
                                        {{ item }}
                                    </Option>
                                </Select>
                            </FormItem>
                            <FormItem label="免疫性疾病：" v-if="caseInfo['免疫性疾病'] != null">
                                <Select transfer multiple v-model.sync="caseInfo['免疫性疾病']['answer']" placeholder="请选择">
                                    <Option v-for="item in caseInfo['免疫性疾病']['choice']" :value="item" :key="item">
                                        {{ item }}
                                    </Option>
                                </Select>
                            </FormItem>
                            <FormItem label="胃肠道疾病：" v-if="caseInfo['胃肠道疾病'] != null">
                                <Select transfer multiple v-model.sync="caseInfo['胃肠道疾病']['answer']" placeholder="请选择">
                                    <Option v-for="item in caseInfo['胃肠道疾病']['choice']" :value="item" :key="item">
                                        {{ item }}
                                    </Option>
                                </Select>
                            </FormItem>
                            <FormItem label="精神神经性疾病：" v-if="caseInfo['精神神经性疾病'] != null">
                                <Select transfer multiple v-model.sync="caseInfo['精神神经性疾病']['answer']" placeholder="请选择">
                                    <Option v-for="item in caseInfo['精神神经性疾病']['choice']" :value="item" :key="item">
                                        {{ item }}
                                    </Option>
                                </Select>
                            </FormItem>
                            <FormItem label="抗生素相关副作用：" v-if="caseInfo['抗生素相关副作用'] != null">
                                <Select transfer multiple v-model.sync="caseInfo['抗生素相关副作用']['answer']" placeholder="请选择">
                                    <Option v-for="item in caseInfo['抗生素相关副作用']['choice']" :value="item" :key="item">
                                        {{ item }}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Form>
                    </div>
                </Card>
            </i-col>
            <i-col :md="12" :lg="8">
                <Card style="margin: 10px 0">
                    <p slot="title">2.过敏史</p>
                    <Form :label-width="120">
                        <FormItem label="过敏史：" v-if="caseInfo['过敏史'] != null">
                            <textarea style="width: 100%" v-model="caseInfo['过敏史']['answer']" placeholder="请输入"/>
                        </FormItem>
                        <FormItem label="过敏性疾病："  v-if="caseInfo['过敏性疾病'] != null">
                            <Select transfer multiple v-model.sync="caseInfo['过敏性疾病']['answer']" placeholder="请选择">
                                <Option v-for="item in caseInfo['过敏性疾病']['choice']" :value="item" :key="item">
                                    {{ item }}
                                </Option>
                            </Select>
                        </FormItem>
                    </Form>
                </Card>
            </i-col>
            <i-col :md="12" :lg="8">
                <Card style="margin: 10px 0">
                    <p slot="title">3.既往史</p>
                    <Form :label-width="120">
                        <FormItem label="既往史："  v-if="caseInfo['既往史'] != null">
                            <Select transfer multiple v-model.sync="caseInfo['既往史']['answer']" placeholder="请选择">
                                <Option v-for="item in caseInfo['既往史']['choice']" :value="item" :key="item">
                                    {{ item }}
                                </Option>
                            </Select>
                        </FormItem>
                    </Form>
                </Card>
            </i-col>
            <i-col :md="12" :lg="8">
                <Card style="margin: 10px 0">
                    <p slot="title">4.病史</p>
                    <Form :label-width="120">
                        <FormItem label="本次患病时长：" v-if="caseInfo['本次患病多久了'] != null">
                            <Select transfer v-model.sync="caseInfo['本次患病多久了']['answer']" placeholder="请选择">
                                <Option v-for="item in caseInfo['本次患病多久了']['choice']" :value="item" :key="item">
                                    {{ item }}
                                </Option>
                            </Select>
                        </FormItem>
                        <FormItem label="本次咨询到以下医院就诊过："  v-if="caseInfo['本次咨询是否到医院就诊过'] != null">
                            <p style="color: rgb(136, 135, 135);display: none"
                               v-if="caseInfo.本次咨询是否到医院就诊过 == null || caseInfo.本次咨询是否到医院就诊过 == ''">
                                {{caseInfo['本次咨询是否到医院就诊过']['answer'] = '本次咨询未到医院就诊过'}}
                            </p>
                            <textarea style="width: 100%" v-model="caseInfo['本次咨询是否到医院就诊过']['answer']" placeholder="请输入"/>
                        </FormItem>
                        <FormItem label="病史：" v-if="caseInfo['病史'] != null">
                            <textarea style="width: 100%" v-model="caseInfo['病史']['answer']" placeholder="请输入"/>
                        </FormItem>
                        <FormItem label="病史附件：" v-if="caseInfo['附件'] != null">
                            <div class="group-row">
                                <div v-for="(item, index) in caseInfo['附件']['answer']">
                                    <img :data-original='`${item}`' :src="item" style="max-height: 120px;max-width: 100%;margin: 10px">
                                </div>
                            </div>
                        </FormItem>
                        <FormItem label="近期病情变化：" v-if="followCaseInfo != null && followCaseInfo['近期病情变化'] != null">
                            <Select transfer v-model.sync="followCaseInfo['近期病情变化']['answer']" placeholder="请选择">
                                <Option v-for="item in followCaseInfo['近期病情变化']['choice']" :value="item" :key="item">
                                    {{ item }}
                                </Option>
                            </Select>
                        </FormItem>
                    </Form>
                </Card>
            </i-col>
            <i-col :md="12" :lg="8">
                <Card style="margin: 10px 0">
                    <p slot="title">5.胃肠道症状表现</p>
                    <Form :label-width="120">
                        <FormItem label="有哪些胃肠道症状：" v-if="caseInfo['有哪些胃肠道症状'] != null">
                            <Select transfer v-model.sync="caseInfo['有哪些胃肠道症状']['answer']" placeholder="请选择">
                                <Option v-for="item in caseInfo['有哪些胃肠道症状']['choice']" :value="item" :key="item">
                                    {{ item }}
                                </Option>
                            </Select>
                        </FormItem>
                        <FormItem label="大便性状为：" v-if="caseInfo['大便性状'] != null">
                            <Select transfer v-model.sync="caseInfo['大便性状']['answer']" placeholder="请选择">
                                <Option v-for="item in caseInfo['大便性状']['choice']" :value="item" :key="item">
                                    {{ item }}
                                </Option>
                            </Select>
                        </FormItem>
                    </Form>
                </Card>
            </i-col>
            <i-col :md="12" :lg="8">
                <Card style="margin: 10px 0">
                    <p slot="title">6.目前治疗</p>
                    <Form :label-width="120">
                        <FormItem label="饮食干预：" v-if="caseInfo['目前治疗中的饮食干预'] != null">
                            <Select transfer v-model.sync="caseInfo['目前治疗中的饮食干预']['answer']" placeholder="请选择">
                                <Option v-for="item in caseInfo['目前治疗中的饮食干预']['choice']" :value="item" :key="item">
                                    {{ item }}
                                </Option>
                            </Select>
                        </FormItem>
                        <FormItem label="饮食干预是否严格：" v-if="followCaseInfo != null && followCaseInfo['饮食干预是否严格'] != null">
                            <Select transfer v-model.sync="followCaseInfo['饮食干预是否严格']['answer']" placeholder="请选择">
                                <Option v-for="item in followCaseInfo['饮食干预是否严格']['choice']" :value="item" :key="item">
                                    {{ item }}
                                </Option>
                            </Select>
                        </FormItem>
                        <FormItem label="药物及营养素：" v-if="caseInfo['目前治疗中的药物及营养素'] != null">
                            <Select transfer v-model.sync="caseInfo['目前治疗中的药物及营养素']['answer']" placeholder="请选择">
                                <Option v-for="item in caseInfo['目前治疗中的药物及营养素']['choice']" :value="item" :key="item">
                                    {{ item }}
                                </Option>
                            </Select>
                        </FormItem>
                        <FormItem label="患者当前使用的药物：" v-if="caseInfo['患者当前使用的药物'] != null">
                            <textarea style="width: 100%" v-model="caseInfo['患者当前使用的药物']['answer']" placeholder="请输入"/>
                        </FormItem>
                        <FormItem label="患者在使用的营养素/药品：" v-if="followCaseInfo['使用的营养素/药品'] != null">
                            <textarea style="width: 100%" v-model="followCaseInfo['使用的营养素/药品']['answer']" placeholder="请输入"/>
                        </FormItem>
                    </Form>
                </Card>
            </i-col>
            <i-col :md="12" :lg="8">
                <Card style="margin: 10px 0">
                    <p slot="title">7.自我评价</p>
                    <p style="color: rgb(136, 135, 135)">0:正常，无症状；10：极度异常，症状严重，无法忍受</p>
                    <Form :label-width="120">
                        <FormItem :label="item" v-for="(item, i) in Object.keys(caseInfo.自我评价.answer)" :key="i" v-if="caseInfo.自我评价.answer != null">
                            <InputNumber :min="0" :max="10" v-model="caseInfo.自我评价.answer[item].rate"
                                         placeholder="请输入分值"></InputNumber>
                        </FormItem>
                    </Form>
                </Card>
            </i-col>
            <i-col :md="12" :lg="8">
                <Card style="margin: 10px 0">
                    <p slot="title">8.患者上传的图片</p>

                    <div>
                        <p style="color: rgb(136, 135, 135)">病情相关的检查结果图片</p>
                        <div class="group-row" v-if="caseInfo.病情相关的检查结果!= null">
                            <div v-for="(item, index) in caseInfo.病情相关的检查结果.answer">
                                <img :data-original='`${item}`' :src="item" style="max-height: 120px;max-width: 100%;margin: 10px">
                            </div>
                        </div>
                    </div>
                    <div>
                        <p style="color: rgb(136, 135, 135)">处方/药盒照片</p>
                        <!--{{JSON.parse(caseInfo.病情相关的检查结果)}}-->
                        <div class="group-row" v-if="caseInfo['处方/药盒照片'] != null">
                            <div v-for="(item, index) in caseInfo['处方/药盒照片'].answer">
                                <!--<img :src="item" style="max-height: 120px;max-width: 100%;margin: 10px">-->
                                <img :data-original='`${item}`' :src="item" style="max-height: 120px;max-width: 100%;margin: 10px">
                            </div>
                        </div>
                    </div>
                    <div v-if="followCaseInfo['如果有新的检查结果，请上传图片'] != null">
                        <p style="color: rgb(136, 135, 135)">新的检查结果图片</p>
                        <!--{{JSON.parse(caseInfo.病情相关的检查结果)}}-->
                        <div class="group-row">
                            <div v-for="(item, index) in followCaseInfo['如果有新的检查结果，请上传图片'].answer">
                                <!--<img :src="item" style="max-height: 120px;max-width: 100%;margin: 10px">-->
                                <img :data-original='`${item}`' :src="item" style="max-height: 120px;max-width: 100%;margin: 10px">
                            </div>
                        </div>
                    </div>
                </Card>
            </i-col>
        </Row>
    </Row>

</template>
<script>
    import Viewer from 'viewerjs';
    import ICol from "../../../node_modules/iview/src/components/grid/col.vue";
    export default {
        components: {ICol},
        name: "patient-diagnose",
        props: {
            caseData: {
                type: Object,
                default: null
            },
            isFirst: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                wHeight: window.innerHeight - 69,
                user: null,
                caseInfo: {},
                caseData: null,
                firstQuestions: null,
                followQuestions: null,
                otherCaseData:null,
                followCaseInfo: {}
            }
        },
        created() {
            this.user = this.$store.state.currentPatient
            this.getUserCase()
            this.getLatestCase()
        },
        methods: {
            checkUser () {
                if (this.user == null || this.user.id == null){
                    this.$Notice.error({title: '请重新登录'})
                    this.$router.push('/')
                    return
                }
            },
            // 获取最近一条病历
            getUserCase() {
                this.checkUser()
                this.infoLoading = true
                this.$http.post('medicalRecord/getResult', {
                    userId: this.user.id,
                    isFirst: true,
                    pageSize: 1
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        if (msg.data.list != null && msg.data.list.length > 0) {
                            this.caseData = msg.data.list[0]
                            this.caseInfo = JSON.parse(this.caseData.result)
                            console.log(this.caseInfo)
                            // 如果是首诊，用caseData存储首诊的caseData，如果是随诊，用otherCaseData存储首诊的caseData
                            if (this.user.isFirst) {
                                this.caseData = msg.data.list[0]
                                this.caseInfo = JSON.parse(this.caseData.result)
                            } else {
                                this.otherCaseData = msg.data.list[0]
                                this.caseInfo = JSON.parse(this.otherCaseData.result)
                            }
                            this.getfirstQuestion()
                            setTimeout(() => {
                                this.initImageTools()
                            }, 200)
                        }
                    } else {
                        this.$Notice.error({title: '病历查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.infoLoading = false
                    this.myError(res.body)
                })
            },
            // 获取最近一条随诊病历
            getLatestCase() {
                this.checkUser()
                this.infoLoading = true
                this.$http.post('medicalRecord/getResult', {
                    userId: this.user.id,
                    isFirst: false,
                    pageSize: 1
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        if (msg.data.list != null && msg.data.list.length > 0) {
                            // 如果是首诊，用otherCaseData存储随诊的caseData，如果是随诊，用caseData存储随诊的caseData
                            if (this.user.isFirst) {
                                this.otherCaseData = msg.data.list[0]
                                this.followCaseInfo = JSON.parse(this.otherCaseData.result)
                            } else {
                                this.caseData = msg.data.list[0]
                                this.followCaseInfo = JSON.parse(this.caseData.result)
                            }
                            console.log('followCaseInfofollowCaseInfo', this.followCaseInfo)
                            this.getFollowQuestion()
                        }
                    } else {
                        this.$Notice.error({title: '病历查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.infoLoading = false
                    this.myError(res.body)
                })
            },
            // 获取首诊问题
            getfirstQuestion () {
                this.$http.get('medicalRecord/firstQuestion').then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.firstQuestions = msg.data
                        this.bindAnswerToQuestion(true)
                    } else {
                        this.$Notice.error({title: '病历查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.infoLoading = false
                    this.myError(res.body)
                })
            },
            // 获取随诊问题
            getFollowQuestion () {
                this.$http.get('medicalRecord/followQuestion').then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.followQuestions = msg.data
                        this.bindAnswerToQuestion(false)
                    } else {
                        this.$Notice.error({title: '病历查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.infoLoading = false
                    this.myError(res.body)
                })
            },
            // 把病历答案绑定回问题
            bindAnswerToQuestion (isFirst) {
                if (isFirst) {
                    this.firstQuestions.map(item => {
                        item.questions.map(question => {
                            if (this.caseInfo[question.question] != null) {
                                let temp = question
                                question['answer'] = JSON.parse(JSON.stringify(this.caseInfo[question.question]))
                                this.caseInfo[question.question] = temp
                                // 如果有选项，则看答案中是否有不在选项中的其它自定义输入内容
                                if (question.choice != null && question.choice.length > 0) {
                                    if (Array.isArray(question.answer)) {
                                        question.answer.map(ans => {
                                            if (question.choice.indexOf(ans) < 0){
                                                question.choice.push(ans)
                                            }
                                        })
                                    } else {
                                        if (question.choice.indexOf(question.answer) < 0){
                                            question.choice.push(question.answer)
                                        }
                                    }
                                }
                            }
                        })
                    })
                } else {
                    console.log('this.followQuestions', this.followQuestions)
                    if (this.followQuestions == null || this.followQuestions.length <= 0) {
                        return
                    }
                    this.followQuestions.map(item => {
                        item.questions.map(question => {
                            if (this.followCaseInfo[question.question] != null) {
                                let temp = question
                                question['answer'] = JSON.parse(JSON.stringify(this.followCaseInfo[question.question]))
                                this.followCaseInfo[question.question] = temp
                                console.log('question', question)
//                                // 如果有选项，则看答案中是否有不在选项中的其它自定义输入内容
                                if (question.choice != null && question.choice.length > 0) {
                                    if (Array.isArray(question.answer)) {
                                        question.answer.map(ans => {
                                            if (question.choice.indexOf(ans) < 0){
                                                question.choice.push(ans)
                                            }
                                        })
                                    } else {
                                        if (question.choice.indexOf(question.answer) < 0){
                                            question.choice.push(question.answer)
                                        }
                                    }
                                }
                            }
                        })
                    })
                }
                console.log('followCaseInfo', this.followCaseInfo)
            },
            initImageTools() {
                //初始化 viewerjs
                setTimeout(()=>{
                    this.ViewerDom = document.getElementById('imgTools');
                    const viewer = new Viewer(this.ViewerDom, {
                        url: "data-original",
                        show: function () {
                            viewer.update()
                        }
                    });
                }, 300)
            },
        }
    }
</script>

<style scoped>

</style>
